// Four-axis Personal Assistant mode gate (PA-1a).
//
// Per docs/planning/personal_assistant_mode_plan.md §3.1, §4.2 and
// docs/planning/gating_audit_and_role_discipline.md — all axes must
// pass; impersonation blocks entirely.

import type { AssistMode } from "./paAssistModeStorage.js";
import type { HasRoleProbe } from "../capabilities/capabilityResolution.js";

export const PERSONAL_ASSISTANT_ALLOWED_ROLES = [
  "owner",
  "org_owner",
  "admin",
  "org_admin",
] as const;

export type PaModeGateInput = {
  authReady: boolean;
  impersonationActive: boolean;
  personalAssistantEnabled: boolean;
  hasRole: HasRoleProbe;
  hasPersonalAssistantCapability: boolean;
  assistMode: AssistMode;
};

function hasAllowedPaRole(hasRole: HasRoleProbe): boolean {
  return hasRole(...PERSONAL_ASSISTANT_ALLOWED_ROLES);
}

/** Prerequisites for showing the session toggle (all axes except assistMode). */
export function canShowPersonalAssistantToggle(input: PaModeGateInput): boolean {
  if (!input.authReady) return false;
  if (input.impersonationActive) return false;
  if (!input.personalAssistantEnabled) return false;
  if (!hasAllowedPaRole(input.hasRole)) return false;
  if (!input.hasPersonalAssistantCapability) return false;
  return true;
}

/** Full four-axis gate — Personal Assistant thread shell is active. */
export function isPersonalAssistantModeActive(input: PaModeGateInput): boolean {
  return canShowPersonalAssistantToggle(input) && input.assistMode === "personal_assistant";
}
